import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SelectionType } from '@swimlane/ngx-datatable';
import { Constants } from '../../utils/constants';
import { HostListener } from "@angular/core";
import { LocalStorageService } from '../../services/local-storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CalendarTypeEnum } from '@trademe/ng-add-to-calendar/dist/model/calendar-type.enum';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {

  ROLES = Constants.ROLES;

  @ViewChild('myTable') table;

  @Input() columns: any[];
  @Input() data = [];
  @Input() currentPage;
  @Input() pageSize;
  @Input() totalItems;
  @Input() isLoading;
  @Input() hideEditInGlobalItem;
  @Input() hideDeleteInGlobalItem;
  @Input() titleCard: string;
  @Input() statusOptions: any[] = [];

  @Input() hideEditAction: boolean = false;
  @Input() hideDeleteAction: boolean = false;
  @Input() hideViewAction: boolean = true;
  // Ícono (feather) y tooltip opcional de la acción "ver"; por defecto, el ojo sin tooltip
  @Input() viewActionIcon: string = 'ft-eye';
  @Input() viewActionTooltip: string;
  @Input() hideSearchBar: boolean = false;
  @Input() hideChangeMode: boolean = false;

  @Input() withHeaderShadow:boolean = true;
  @Input() withHeaderDivider:boolean = false;

  @Output() loadMore = new EventEmitter<string>();
  @Output() editRow = new EventEmitter<string>();
  @Output() viewRow = new EventEmitter<string>();
  @Output() deleteRow = new EventEmitter<string>();
  @Output() deleteManyRow = new EventEmitter<any[]>();
  @Output() sendSearch = new EventEmitter<string>();
  @Output() buttonAction = new EventEmitter<string>();
  @Output() linkAction = new EventEmitter<string>();
  @Output() statusAction = new EventEmitter<string>();
  @Output() copyOnClipboardRow = new EventEmitter<string>();
  @Output() reSendRow = new EventEmitter<string>();
  @Output() sortChange = new EventEmitter<{ column: any; newValue: string }>();

  @Input() externalSorting: boolean = false;
  @Input() defaultSortProp: string = null;
  @Input() defaultSortDir: string = null;

  activeSortProp: string = null;
  activeSortDir: string = null;
  currentSorts: any[] = [];



  //data: T[];
  selected = [];
  SelectionType = SelectionType;
  modeMobile: boolean = false;
  showChangeMode: boolean = false;
  form: FormGroup;
  calendarOptionSelected: any[] = [];

  calendarOptions = [
    { type: CalendarTypeEnum.google, name: "Google calendar" },
    { type: CalendarTypeEnum.iCalendar, name: "iCalendar" },
    { type: CalendarTypeEnum.outlook, name: "Outlook calendar" }
  ]
  constructor(
    private localStorage: LocalStorageService,
    private formBuilder: FormBuilder) {
    this.onResize();
    
  }

  ngOnInit(): void {
    console.log("DATA ", this.data);
    this.form = this.formBuilder.group({
      text: ['']
    });
    if (this.defaultSortProp) {
      this.activeSortProp = this.defaultSortProp;
      this.activeSortDir = this.defaultSortDir || 'asc';
      this.currentSorts = [{ prop: this.defaultSortProp, dir: this.activeSortDir }];
    }
  }

  get f() { return this.form.controls; }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let screenWidth = window.innerWidth;
    if (screenWidth < 768) {
      this.showChangeMode = false;
      this.modeMobile = true;
    } else {
      this.showChangeMode = true;
    }
  }

  filterColumns() {
    if (this.columns) {
      return this.columns.filter(x => { return x.type != 'actions' && x.type != 'actions-more' });
    } else {
      return;
    }
  }

  getActionCol() {
    if (this.columns) {
      return this.columns.filter(x => { return x.type == 'actions' });
    } else {
      return;
    }
  }

  getActionMoreCol() {
    if (this.columns) {
      return this.columns.filter(x => { return x.type == 'actions-more' });
    } else {
      return;
    }
  }

  deleteAction(btnElement, row) {
    btnElement && btnElement.parentElement && btnElement.parentElement.parentElement && btnElement.parentElement.parentElement.blur();
    this.deleteRow.emit(row);
  }

  deleteAllAction(btnDeleteAll) {
    this.deleteManyRow.emit(this.selected);
  }

  // SELECTION LOGIC
  onSelect({ selected }) {
    if (this.hideDeleteInGlobalItem) {
      selected = selected.filter((item) => {
        if (item.clientID) {
          return item;
        }
      })
    }
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  onActivate(event) {
  }

  add() {
    this.selected.push(this.data[1], this.data[3]);
  }

  update() {
    this.selected = [this.data[1], this.data[3]];
  }

  remove() {
    this.selected = [];
  }

  displayCheck(row) {
    return row.name !== 'Ethel Price';
  }

  showEdit(row) {
    if (this.hideEditInGlobalItem) {
      if (row.clientID || row.clientId) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  showDelete(row) {
    let user = this.localStorage.getUser();
    if (user.isSuperAdmin() && user.clientID == null) {
      return true;
    }
    if (this.hideDeleteInGlobalItem) {
      if (row.clientID || row.clientId) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  disableSelectAll() {
    let user = this.localStorage.getUser();
    if (user.isSuperAdmin() && user.clientID == null) {
      return false;
    }
    if (this.hideDeleteInGlobalItem) {
      let itemsNoGlobal = this.data.filter((item) => {
        if (item.clientID || item.clientId) {
          return item;
        }
      });
      if (itemsNoGlobal && itemsNoGlobal.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  showSelection(row, isSelected) {
    if (this.hideDeleteInGlobalItem) {
      if (!row.clientID || row.clientId) {
        return false;
      }
    }
    return isSelected;
  }

  changeModeCard() {
    this.modeMobile = true;
  }

  changeModeTable() {
    this.modeMobile = false;
  }

  getIndexFirstText() {
    let rows = this.filterColumns();
    if (rows[0].type == 'image') {
      return 1;
    }
    return 0;
  }


  getTextCapitalized(text: string): string {
    return Utils.capitalizeEveryWord(text);
  }

  onSort(event: { column: any; newValue: string }): void {
    if (this.externalSorting) {
      this.activeSortProp = event.column.prop;
      this.activeSortDir = event.newValue;
      this.currentSorts = [{ prop: event.column.prop, dir: event.newValue }];
    }
    this.sortChange.emit(event);
  }

}
